import { observer } from "mobx-react-lite";
import { withT } from "./tools";
import select1 from './imgs/select1.png';
import select2 from './imgs/select2.png';
import select3 from './imgs/select3.png';
import select4 from './imgs/select4.png';
import select5 from './imgs/select5.png';
import select6 from './imgs/select6.png';

const chooseConfigList = [
  {
    key: 1,
    icon: select1,
    title: 'group.Selection',
    desc: 'group.xtstarter3',
  },
  {
    key: 2,
    icon: select2,
    title: 'group.xtstarter4',
    desc: 'group.xtstarter5',
  },
  {
    key: 3,
    icon: select3,
    title: 'group.xtstarter6',
    desc: 'group.xtstarter7',
  },
  {
    key: 4,
    icon: select4,
    title: 'group.xtstarter8',
    desc: 'group.xtstarter9',
  },
  {
    key: 5,
    icon: select5,
    title: 'group.Marketing',
    desc: 'group.xtstarter10',
  },
  {
    key: 6,
    icon: select6,
    title: 'group.allService',
    desc: 'group.allServiceTips',
  },
];

const PageToChoose = ({
  t,
}) => {

  return (
    <div
      className="mt-[80px] sm:mt-[40px]"
    >
      <h2 className="font-bold sm:font-medium text-[40px] sm:text-[20px] mb-[15px] text-[#383742]">{t('group.why')}</h2>

      <div className="grid grid-cols-2 sm:grid-cols-1 gap-[30px] sm:gap-[15px]">
        {chooseConfigList.map(item => <ChooseCard key={item.key} choose={item} />)}
      </div>
    </div>
  );
};

export default observer(withT(PageToChoose));

export const ChooseCard = withT(({
  t,
  choose = {},
}) => {
  const { icon, title, desc } = choose;

  return (
    <div
      style={{
        border: '1px solid #f0f2f7',
        boxShadow: '0 2px 4px 0 rgba(64,71,90,.1)',
      }}
      className="flex p-[33px] sm:p-[30px_18px] rounded-[6px]"
    >
      <img src={icon} alt="" className="mr-[30px] sm:mr-[20px] w-[70px] sm:w-[39px] object-contain" />
      <div className="">
        <h3 className="text-[22px] sm:text-[14px] mb-0 font-medium text-[#383742] sm:text-[#383742] sm:mb-[3px]">{t(title)}</h3>
        <p className="text-[16px] sm:text-[11px] mb-0 text-[#8f8e92] sm:text-[#8F8E92]">{t(desc)}</p>
      </div>
    </div>
  );
});
